import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import api from "@/lib/api";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

export default function NotificationBell() {
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch {}
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
  }, []);

  const unread = items.filter((n) => !n.read).length;

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <DropdownMenu dir="rtl">
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative rounded-full" data-testid="notif-bell">
          <Bell className="w-5 h-5" />
          {unread > 0 && (
            <span className="absolute -top-0.5 -end-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-accent text-white text-[10px] font-bold flex items-center justify-center" data-testid="notif-count">
              {unread}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 p-0 max-h-96 overflow-auto no-scrollbar">
        <div className="flex items-center justify-between p-3 border-b sticky top-0 bg-card z-10">
          <span className="font-bold text-sm">الإشعارات</span>
          {unread > 0 && (
            <button onClick={markAll} className="text-xs text-primary" data-testid="notif-mark-read">
              تعليم الكل كمقروء
            </button>
          )}
        </div>
        {items.length === 0 ? (
          <div className="p-6 text-center text-sm text-muted-foreground">لا توجد إشعارات</div>
        ) : (
          items.map((n) => (
            <div key={n.id} className={`p-3 border-b text-start ${!n.read ? "bg-primary/5" : ""}`}>
              <div className="text-sm font-semibold">{n.title}</div>
              <div className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{n.body}</div>
            </div>
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
